<template>
  <div class="d-flex justify-space-around">
    <div class="wrap">
      <div class="border">
        <div class="border__box">
          <div class="padding"></div>
          <v-form ref="form" class="box" lazy-validation v-model="valid" id="target">
            <div class="box_header">
              <div class="box_header_text f18 fw500">
                {{ t.header }}
                <span class="f18 fw500"> AA000000A </span>
              </div>
              <div class="box_header_date f14">
                {{ new Date().toLocaleDateString() }}
              </div>
            </div>
            <div class="box_body">
              <div class="box_body_title">
                <h4 class="f30 fw500">Company Oy</h4>
                <span class="f16">Address</span>
              </div>
              <div class="box_body_info">
                <div class="box_body_info_item">
                  <div class="box_body_info_item_title f16 fw500">{{ t.project_name }}:</div>
                  <div class="box_body_info_item_text f16">Project name</div>
                </div>
              </div>
              <div class="box_body_info_item">
                <div class="box_body_info_item_title f16 fw500">{{ t.project_address }}:</div>
                <div class="box_body_info_item_text f16">Street, postal code, city</div>
              </div>
              <div class="box_body_info_item">
                <div class="box_body_info_item_title f16 fw500">{{ t.contact_person }}:</div>
                <div class="box_body_info_item_text three f16">
                  <p>Contact person name</p>
                  <p>+ 358 12 345 67 89</p>
                  <p>email@mail.com</p>
                </div>
              </div>
              <div class="box_body_info_item">
                <div class="box_body_info_item_title f16 fw500">
                  {{
                    localStorage.translations.pages.sales_project['project_client-labels'][
                      'segment-vida-deyatelnosti'
                    ]
                  }}:
                </div>
                <div class="box_body_info_item_text f16">Masonry</div>
              </div>
              <div class="box_body_table">
                <table border="1" class="f16">
                  <tr>
                    <th class="fw500 text-center border-top border-left border-bottom">
                      {{ t_table.title }}
                    </th>
                    <th class="fw500 text-center border-top border-left border-bottom">
                      {{ t_table.unit }}
                    </th>
                    <th class="fw500 text-center border-top border-left border-bottom">
                      {{ t_table.amount }}
                    </th>
                    <th class="fw500 text-center border-top border-left border-bottom">
                      {{ t_table.price_unit }}
                    </th>
                    <th
                      class="fw500 text-center border-top border-left border-bottom border-right"
                      id="table_all"
                      ref="table_all"
                    >
                      {{ t_table.in_total }}
                    </th>
                  </tr>
                  <tr v-for="(item, index) in tableData" :key="index">
                    <td class="border-left border-bottom">{{ item.name }}</td>
                    <td align="center" class="border-left border-bottom">{{ item.measure }}</td>
                    <td align="center" class="border-left border-bottom">{{ item.work_amount }}</td>
                    <td align="center" class="border-left border-bottom">{{ item.price }}</td>
                    <td align="center" nowrap class="border-left border-bottom border-right">
                      <span class="last-col"> {{ item.total }} </span>
                    </td>
                  </tr>
                </table>
                <div class="price f16 fw500">
                  {{ t_table.in_total }}
                  <div class="price_box">10 400,00 €</div>
                </div>
              </div>
              <div class="box_body_inputs gap-4" :class="{ read: false }">
                <div class="box_body_inputs_item">
                  <BaseInput
                    type="autocomplete"
                    v-model="allData.project_offer_vat.value"
                    :label="t.price_in_euros"
                    :items="priceList"
                    :view-value="allData.project_offer_vat.value"
                    v-bind="presetBaseInput"
                    @change="disable_vat = false"
                  >
                    <template slot="append-outer">
                      <v-btn
                        color="primary"
                        class="btn-pt"
                        depressed
                        :disabled="!navigationGuardianActive == true && disable_vat == false
                          ? !navigationGuardianActive && (disable_vat = true)
                          : disable_vat"
                        @click="prepareData(allData.project_offer_vat)"
                      >
                        <BaseIcon width="20" height="20" icon="button-save" />
                      </v-btn>
                    </template>
                  </BaseInput>
                </div>
                <div class="box_body_inputs_item">
                  <BaseInput
                    type="textarea"
                    v-model="allData.project_offer_commentary.value"
                    :label="t.commentary"
                    :view-value="allData.project_offer_commentary.value"
                    v-bind="presetBaseInput"
                    rows="1"
                    auto-grow
                    @input="disable_commentary = false"
                  >
                    <template slot="append-outer">
                      <v-btn
                        color="primary"
                        class="btn-pt"
                        depressed
                        :disabled="!navigationGuardianActive == true && disable_commentary == false
                          ? !navigationGuardianActive && (disable_commentary = true)
                          : disable_commentary"
                        @click="prepareData(allData.project_offer_commentary)"
                      >
                        <BaseIcon width="20" height="20" icon="button-save" />
                      </v-btn>
                    </template>
                  </BaseInput>
                </div>
                <div class="box_body_inputs_item">
                  <BaseInput
                    type="textarea"
                    v-model="allData.project_offer_from_customer.value"
                    :label="t.from_the_customer"
                    :view-value="allData.project_offer_from_customer.value"
                    v-bind="presetBaseInput"
                    rows="1"
                    auto-grow
                    @input="disable_customer = false"
                  >
                    <template slot="append-outer">
                      <v-btn
                        color="primary"
                        class="btn-pt"
                        depressed
                        :disabled="!navigationGuardianActive == true && disable_customer == false
                          ? !navigationGuardianActive && (disable_customer = true)
                          : disable_customer"
                        @click="prepareData(allData.project_offer_from_customer)"
                      >
                        <BaseIcon width="20" height="20" icon="button-save" />
                      </v-btn>
                    </template>
                  </BaseInput>
                </div>
                <div class="box_body_inputs_item">
                  <BaseInput
                    type="textarea"
                    v-model="allData.project_offer_from_contractor.value"
                    :label="t.from_the_contractor"
                    :view-value="allData.project_offer_from_contractor.value"
                    v-bind="presetBaseInput"
                    rows="1"
                    auto-grow
                    @input="disable_contractor = false"
                  >
                    <template slot="append-outer">
                      <v-btn
                        color="primary"
                        class="btn-pt"
                        depressed
                        :disabled="!navigationGuardianActive == true && disable_contractor == false
                          ? !navigationGuardianActive && (disable_contractor = true)
                          : disable_contractor"
                        @click="prepareData(allData.project_offer_from_contractor)"
                      >
                        <BaseIcon width="20" height="20" icon="button-save" />
                      </v-btn>
                    </template>
                  </BaseInput>
                </div>
                <div class="box_body_inputs_item">
                  <BaseInput
                    type="textarea"
                    v-model="allData.project_offer_price_includes.value"
                    :label="t.offer_price_includes"
                    :view-value="allData.project_offer_price_includes.value"
                    v-bind="presetBaseInput"
                    rows="1"
                    auto-grow
                    @input="disable_price = false"
                  >
                    <template slot="append-outer">
                      <v-btn
                        color="primary"
                        class="btn-pt"
                        depressed
                        :disabled="!navigationGuardianActive == true && disable_price == false
                          ? !navigationGuardianActive && (disable_price = true)
                          : disable_price"
                        @click="prepareData(allData.project_offer_price_includes)"
                      >
                        <BaseIcon width="20" height="20" icon="button-save" />
                      </v-btn>
                    </template>
                  </BaseInput>
                </div>
                <div class="box_body_inputs_item w375">
                  <div class="d-flex flex-column">
                    <label class="f14 primary--text font-weight-medium customLineHeight">
                      {{ t.payment_method }}
                    </label>
                    <span class="f16">1 pv netto.</span>
                  </div>
                </div>
                <div class="box_body_inputs_item w375">
                  <div class="d-flex flex-column">
                    <label class="f14 primary--text font-weight-medium customLineHeight">
                      {{ t.offer_valid }}
                    </label>
                    <span class="f16"> 31.12.2099 </span>
                  </div>
                </div>
                <div class="box_body_inputs_item">
                  <BaseInput
                    type="textarea"
                    v-model="allData.project_offer_notes.value"
                    :label="t.note"
                    :view-value="allData.project_offer_notes.value"
                    v-bind="presetBaseInput"
                    :rows="3"
                    auto-grow
                    @input="disable_notes = false"
                  >
                    <template slot="append-outer">
                      <v-btn
                        color="primary"
                        class="btn-pt"
                        depressed
                        :disabled="!navigationGuardianActive == true && disable_notes == false
                          ? !navigationGuardianActive && (disable_notes = true)
                          : disable_notes"
                        @click="prepareData(allData.project_offer_notes)"
                      >
                        <BaseIcon width="20" height="20" icon="button-save" />
                      </v-btn>
                    </template>
                  </BaseInput>
                </div>
                <div class="box_body_inputs_item">
                  <BaseInput
                    type="textarea"
                    v-model="allData.project_offer_sign.value"
                    :label="localStorage.translations.pages.common.buttons.sign"
                    :view-value="allData.project_offer_sign.value"
                    v-bind="presetBaseInput"
                    :rows="3"
                    auto-grow
                    @input="disable_sign = false"
                  >
                    <template slot="append-outer">
                      <v-btn
                        color="primary"
                        class="btn-pt"
                        depressed
                        :disabled="!navigationGuardianActive == true && disable_sign == false
                          ? !navigationGuardianActive && (disable_sign = true)
                          : disable_sign"
                        @click="prepareData(allData.project_offer_sign)"
                      >
                        <BaseIcon width="20" height="20" icon="button-save" />
                      </v-btn>
                    </template>
                  </BaseInput>
                </div>
              </div>
            </div>
          </v-form>
          <div class="padding" />
          <v-divider />
        </div>
      </div>
    </div>
    <div class="fixedBtn">
      <BaseTooltip
        v-if="edit"
        :tooltip="localStorage.translations.pages.common['buttons']['sohranit']"
      >
        <BaseButton
          :disabled="!navigationGuardianActive"
          @click="prepareAllData(allData)"
          round
          icon_only
          size="60"
          default_icon="button-save"
        />
      </BaseTooltip>
      <BaseTooltip
        v-else
        :tooltip="localStorage.translations.pages.common['buttons']['redaktirovat']"
      >
        <BaseButton @click="onEdit" round size="60" icon_only default_icon="button-edit" />
      </BaseTooltip>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'settingTemplateOfferPage',
  data: () => ({
    valid: true,
    priceList: ['ALV 0%', 'ALV 10%', 'ALV 14%', 'ALV 24%'],
    allData: {
      project_offer_vat: {
        name: 'project_offer_vat',
        value: '',
        id: 10,
      },
      project_offer_commentary: {
        name: 'project_offer_commentary',
        value: '',
        id: 1,
      },
      project_offer_from_customer: {
        name: 'project_offer_from_customer',
        value: '',
        id: 2,
      },
      project_offer_from_contractor: {
        name: 'project_offer_from_contractor',
        value: '',
        id: 3,
      },
      project_offer_price_includes: {
        name: 'project_offer_price_includes',
        value: '',
        id: 4,
      },
      project_offer_notes: {
        name: 'project_offer_notes',
        value: '',
        id: 5,
      },
      project_offer_sign: {
        name: 'project_offer_sign',
        value: '',
        id: 6,
      },
    },
    disable_vat: true,
    disable_commentary: true,
    disable_customer: true,
    disable_contractor: true,
    disable_price: true,
    disable_notes: true,
    disable_sign: true,
    fieldsLabels: [
      'project_offer_commentary',
      'project_offer_from_customer',
      'project_offer_from_contractor',
      'project_offer_price_includes',
      'project_offer_notes',
      'project_offer_sign',
      'project_offer_vat',
    ],
  }),
  computed: {
    ...mapGetters('navigationGuardian', ['navigationGuardianActive']),
    ...mapGetters(['inputRules']),
    ...mapGetters('commonContent', ['categoryContentData']),
    t() {
      return this.localStorage.translations.pages.sales_project['price_offer_terms-labels']
    },
    t_table() {
      return this.localStorage.translations.pages.sales_project['price_offer_terms-tables']
    },
    tableData() {
      return [
        {
          name: 'Masonry and construction contracting',
          measure: 'm²',
          work_amount: '200,00',
          price: '52,00',
          total: '10 400,00 €',
        },
        {
          name: 'Price for additional work',
          measure: '€/h',
          work_amount: '-',
          price: '42,00',
          total: '- €',
        },
      ]
    },
    presetBaseInput() {
      return {
        view: !this.edit,
      }
    },
    edit() {
      return this.$route.name === 'SettingOfferTemplateEdit'
    },
  },
  created() {
    this.getTemplateContentData()
  },
  watch: {
    '$route.name'() {
      this.onCheckChange({ overwrite: true })
    },
    allData: {
      handler() {
        if (this.edit) this.onCheckChange({ overwrite: false })
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    ...mapActions('commonContent', ['onGetCategoryContent', 'onChangeContentData']),
    async getTemplateContentData() {
      let data = {
        category: 'project_offer',
        contentable_type: '',
        contentable_id: '',
      }
      await this.onGetCategoryContent(data).then((res) => {
        let temp = res.data.data.map((i) => i.name)
        for (let i in this.fieldsLabels) {
          let index = temp.indexOf(this.fieldsLabels[i])
          this.allData[this.fieldsLabels[i]].value = res.data.data[index].value
        }
      })
    },
    prepareData(data) {
      let result = {
        content: [
          {
            category: 'project_offer',
            name: data.name,
            value: data.value,
          },
        ],
      }
      this.updateData(result)
    },
    prepareAllData(data) {
      let result = {
        content: [
          {
            category: 'project_offer',
            name: Object.values(data)[0].name,
            value: Object.values(data)[0].value,
          },
          {
            category: 'project_offer',
            name: Object.values(data)[1].name,
            value: Object.values(data)[1].value,
          },
          {
            category: 'project_offer',
            name: Object.values(data)[2].name,
            value: Object.values(data)[2].value,
          },
          {
            category: 'project_offer',
            name: Object.values(data)[3].name,
            value: Object.values(data)[3].value,
          },
          {
            category: 'project_offer',
            name: Object.values(data)[4].name,
            value: Object.values(data)[4].value,
          },
          {
            category: 'project_offer',
            name: Object.values(data)[5].name,
            value: Object.values(data)[5].value,
          },
          {
            category: 'project_offer',
            name: Object.values(data)[6].name,
            value: Object.values(data)[6].value,
          },
        ],
      }
      let multi_field = true
      this.updateData(result, multi_field)
    },
    async updateData(data, multi_field) {
      this.fieldsDisabled()
      await this.onChangeContentData(data)
        .then(() => {
          this.getTemplateContentData()
          this.onSave()
          if (multi_field) {
            this.onEdit()
            this.$store.dispatch(
             'popup/onMessage',
             {
               message:
                this.localStorage.translations.pages.common.notifications[
                 'izmeneniya-uspeshno-sohraneny'
                 ],
               IsError: false,
             },
             { root: true },
            )
            this.dialog = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['oshibka'],
              IsError: true,
            },
            { root: true },
          )
        })
    },
    validate() {
      return this.$refs.form.validate()
    },
    onCheckChange({ overwrite }) {
      this.onNavigationGuardianCheck({
        data: { offerTemplateSettings: this.allData },
        overwrite,
      })
    },
    fieldsDisabled() {
      this.disable_vat = true
      this.disable_commentary = true
      this.disable_customer = true
      this.disable_contractor = true
      this.disable_price = true
      this.disable_notes = true
      this.disable_sign = true
    },
    onEdit() {
      this.$router.push({ name: this.edit ? 'SettingOfferTemplate' : 'SettingOfferTemplateEdit' })
    },
    onSave() {
      if (this.validate()) {
        this.onNavigationGuardianCheck({
          data: { offerTemplateSettings: this.allData},
          overwrite: true,
        })
        this.fileSend = null
        this.edit = false
        document.body.scrollTop = 0 // For Safari
        document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-pt {
  height: 30px !important;
  padding: 0 !important;
  min-width: 30px !important;
}
.customLineHeight {
  line-height: 16px !important;
  margin-bottom: 5px;
}
.black-color {
  :deep() * {
    color: black !important;
  }
}

.wrap {
  max-width: 950px;
  width: 100%;

  .btns {
    display: flex;
    justify-content: flex-start;

    &.center {
      display: grid;
      grid-template-columns: repeat(2, max-content);
      column-gap: 30px;
      justify-content: center;
    }
  }
}

.border {
  border: 1px solid #bedbeb;
  background-color: #fcfcfc;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    margin: 0 8px;
  }

  &-top {
    border-top: 1px solid black;
  }

  &-right {
    border-right: 1px solid black;
  }

  &-bottom {
    border-bottom: 1px solid black;
  }

  &-left {
    border-left: 1px solid black;
  }
}

.text-center {
  text-align: center !important;
}

.padding {
  padding-bottom: 30px;
}

.break-avoid {
  break-inside: avoid;
}

.box {
  color: #000000 !important;
  // page-break-before: avoid;
  &_header {
    display: flex;
    justify-content: space-between;
    padding: 0 30px 30px 30px;
    border-bottom: 1px solid #bedbeb;
    align-content: center;
    align-items: center;

    &_text {
      display: grid;
      grid-template-columns: max-content max-content;
      column-gap: 8px;
      align-items: center;
    }
  }

  &_body {
    padding: 30px 30px 0;
    display: grid;
    row-gap: 30px;
    @media #{map-get($display-breakpoints, 'sm-only')} {
      padding: 15px 15px 0;
    }
    @media #{map-get($display-breakpoints, 'xs-only')} {
      padding: 4px 4px 0;
    }

    &_title {
      display: grid;
      gap: 14px;
      margin-bottom: 30px;
    }

    &_info {
      display: grid;
      row-gap: inherit;

      &_item {
        display: grid;
        grid-template-columns: 170px auto;
        column-gap: 10px;

        &_title {
          height: max-content;
        }

        &_text {
          &.three {
            display: grid;
            row-gap: 8px;

            p {
              margin: 0;
            }
          }
        }
      }
    }

    &_table {
      margin-bottom: 10px;

      &_title {
        margin-bottom: 30px;
      }

      table {
        border-collapse: collapse;
        border-color: transparent;

        th,
        td {
          &:first-of-type {
            width: 529px;
          }

          &:last-of-type {
            width: max-content;
          }
        }

        th {
          text-align: start;
          padding: 14px 10px;
          @media #{map-get($display-breakpoints, 'sm-and-down')} {
            padding: 8px 2px;
          }
          @media #{map-get($display-breakpoints, 'xs-only')} {
            font-size: 10px;
          }

          &:first-of-type {
            padding: 14px 20px;
            @media #{map-get($display-breakpoints, 'sm-and-down')} {
              padding: 2px;
            }
          }
        }

        td {
          padding: 10px;
          @media #{map-get($display-breakpoints, 'sm-and-down')} {
            padding: 6px 2px;
          }
          @media #{map-get($display-breakpoints, 'xs-only')} {
            font-size: 10px;
          }

          &:first-of-type {
            padding: 10px 20px;
            @media #{map-get($display-breakpoints, 'sm-and-down')} {
              padding: 6px 2px;
            }
          }
        }
      }

      .price {
        margin-top: 15px;
        display: grid;
        grid-template-columns: max-content max-content;
        column-gap: 14px;
        align-items: center;
        justify-content: flex-end;
        break-inside: avoid;

        &_box {
          border: 1px solid black;
          padding: 10px;
          text-align: center;
        }
      }
    }

    &_inputs {
      display: grid;

      &.read {
        display: grid;
        row-gap: 30px;
      }

      &_item {
        label {
          line-height: 2.6rem;
        }

        &.w375 {
          width: 375px;
        }

        &_wrap {
          display: grid;
          grid-template-columns: auto max-content;
          column-gap: 10px;

          span {
            margin-top: 14px;
          }
        }
      }
    }
  }
}
</style>